import { render } from "./user-form.vue?vue&type=template&id=0508f5c9&scoped=true"
import script from "./user-form.vue?vue&type=script&lang=js"
export * from "./user-form.vue?vue&type=script&lang=js"

import "./user-form.vue?vue&type=style&index=0&id=0508f5c9&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0508f5c9"]])

export default __exports__